import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69739716"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OTabelaTiposDeAtividade__ColumnConteudo" }
const _hoisted_2 = { class: "OTabelaTiposDeAtividade__ColumnConteudo" }
const _hoisted_3 = { class: "ModalDeAlerta__Botoes" }

import { computed, onMounted, ref } from "vue"
  import { useRouter } from "vue-router"

  import DataTable, {
    DataTableFilterMeta,
    DataTableFilterMetaData,
  } from "primevue/datatable"
  import Column from "primevue/column"
  import PButton from "primevue/button"
  import {
    MModalDeAlerta,
    MInput,
    AEstadoVazioTabela,
    APaginadorDeTabela,
  } from "@/components/Gerais"
  import { OAtributosChips } from "@/components/Atributos"
  import { PageState } from "primevue/paginator"
  import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"

  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import {
    ListarTiposDeAtividade,
    ParamsTiposDeAtividade,
  } from "@/repositorios/tiposDeAtividade/tiposDeAtividade.modelo"
  import { FilterMatchMode, FilterOperator } from "primevue/api"
  import { usarManipuladoresDeTabela } from "@/composable/UsarManipuladoresDeTabela/usarManipuladoresDeTabela"
  import { usarFiltragem } from "@/composable/UsarFiltragem"
  import TiposDeAtividadeRepositorio from "@/repositorios/tiposDeAtividade/tiposDeAtividade.repositorio"
  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import SessaoServico from "@/servicos/sessao.service"
  import { useI18n } from "vue-i18n"
  import { useToast } from "primevue/usetoast"
  import { usarPermissionamento } from "@/composable/UsarPermissionamento"

  interface Props {
    teleportarPara?: string
  }

  type TipoAcao = "excluir" | "arquivar" | "desarquivar"
  
export default /*#__PURE__*/_defineComponent({
  __name: 'OTabelaTiposDeAtividade',
  props: {
    teleportarPara: null
  },
  setup(__props: any) {

  

  const { t } = useI18n()

  const estilo = {
    colunas: {
      nome: {
        width: "22.5%",
      },
      codigo: {
        width: "11%",
      },
      duracaoPadraoEmMinutos: {
        width: "15%",
      },
      atributosEsperados: {
        width: "25%",
      },
      profissionalNecessario: {
        width: "21%",
      },
      acoes: {
        flex: 0,
        width: "100%",
        minWidth: "146px",
        justifyContent: "flex-end",
        minHeight: "49px",
      },
    },
  }

  const ALTURA_RELATIVA_DA_TABELA = "calc(100vh - 280px)"

  const tiposDeAtividadeRep = new TiposDeAtividadeRepositorio()

  const router = useRouter()
  const filtros = ref<DataTableFilterMeta>({
    nome: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
    codigo: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
    profissionalNecessario: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
  })

  const tiposDeAtividade = ref<ListarTiposDeAtividade[]>([])

  const { recuperarHorasDaDuracao, recuperarMinutosDaDuracao } = usarDataHora()
  const { desativarLinhaPorStatus } = usarManipuladoresDeTabela()
  const { onErro } = usarMensagemUsuario()
  const { dadosDoAlerta } = usarMensagemUsuario()
  const toast = useToast()
  
  const acaoAtual = ref<TipoAcao | null>(null)
  const estaProcessandoAcao = ref(false)
  
  const { leitor } = usarLeitorDeDados()
  const { escritor } = usarEscritorDeDados()

  const arquivarTipoDeAtividadeEscritor = escritor<
    { id: string },
    string,
    undefined
  >(tiposDeAtividadeRep.arquivarTipoDeAtividade, ["", undefined])
  const desarquivarTipoDeAtividadeEscritor = escritor<
    { id: string },
    string,
    undefined
  >(tiposDeAtividadeRep.desarquivarTipoDeAtividade, ["", undefined])
  const deletarTiposDeAtividadeEscritor = escritor<void, string, undefined>(
    tiposDeAtividadeRep.deletarTipoDeAtividade,
    ["", undefined]
  )

  const {
    filtros: filtrosComposable,
    preencherFiltro,
    removerFiltro,
  } = usarFiltragem()
  const lerTiposDeAtividade = leitor<
    ListarTiposDeAtividade,
    ParamsTiposDeAtividade
  >(tiposDeAtividadeRep.listarTiposDeAtividade, {
    "ordenar-por": ["desc.ativo", "asc.nome"],
  })

  const carregandoTiposDeAtividade = computed(() => {
    return lerTiposDeAtividade.resultado.status === "pendente"
  })

  const labelModalDeConfirmacao = computed(() => {
    switch (acaoAtual.value) {
      case "excluir":
        return t("simExcluir")
      case "arquivar":
        return t("simArquivar")
      case "desarquivar":
        return t("simDesarquivar")
    }
  })

  const onErroToast = (detalhe: string, resumo: string) => {
    toast.add({
      severity: "error",
      summary: resumo,
      detail: detalhe,
      life: 5000,
      closable: true,
    })
  }

  const formatarDuracao = (duracao: number) => {
    return `
    ${recuperarHorasDaDuracao(duracao)} ${t("horas")} ${t("e")}
    ${recuperarMinutosDaDuracao(duracao)} ${t("minutos")}`
  }

  const { verificarPermissao: permissaoTiposDeAtividade } =
    usarPermissionamento("TiposDeAtividade")

  const temPermissaoParaAlterarTiposDeAtividade = (
    idUsuarioCriador: string
  ): boolean => {
    return permissaoTiposDeAtividade("editar")
  }

  const listarTiposDeAtividade = async (pagina: number, porPagina = 10) => {
    await lerTiposDeAtividade.porPagina(porPagina).pagina(pagina).executar()
    const statusDaRequisicao = lerTiposDeAtividade.resultado.status

    if (statusDaRequisicao === "vazio") {
      tiposDeAtividade.value = []
    }

    if (statusDaRequisicao === "sucesso") {
      tiposDeAtividade.value = lerTiposDeAtividade.resultado.dados
    }
  }

  const desativarTipoDeAtividade = (nomeTituloModal: string, id: string) => {
    acaoAtual.value = "excluir"
    dadosDoAlerta.conteudo = t("aoExcluirTipoDeAtividadeSeraRemovidoDoSistemaPermanentemente")
    dadosDoAlerta.titulo = `${t("excluir")} "${nomeTituloModal}" ?`
    dadosDoAlerta.tipo = "atencao"
    dadosDoAlerta.identificacao = id
    dadosDoAlerta.visivel = true
  }

  const arquivarTipoDeAtividade = (nomeTituloModal: string, id: string) => {
    acaoAtual.value = "arquivar"
    dadosDoAlerta.conteudo = t("aoArquivarTipoDeAtividadeSeraOcultado")
    dadosDoAlerta.titulo = `${t("arquivar")} "${nomeTituloModal}" ?`
    dadosDoAlerta.tipo = "atencao"
    dadosDoAlerta.identificacao = id
    dadosDoAlerta.visivel = true
  }

  const desarquivarTipoDeAtividade = (nomeTituloModal: string, id: string) => {
    acaoAtual.value = "desarquivar"
    dadosDoAlerta.conteudo = t("aoDesarquivarTipoDeAtividadeSeraExibido")
    dadosDoAlerta.titulo = `${t("desarquivar")} "${nomeTituloModal}" ?`
    dadosDoAlerta.tipo = "atencao"
    dadosDoAlerta.identificacao = id
    dadosDoAlerta.visivel = true
  }

  const confirmarAcao = async (id: string) => {
    if (acaoAtual.value === "excluir") {
      await confirmarDesativacao(id)
    } else if (acaoAtual.value === "arquivar") {
      await confirmarArquivacao(id)
    } else if (acaoAtual.value === "desarquivar") {
      await confirmarDesarquivacao(id)
    }
  }

  const confirmarDesativacao = async (id: string) => {
    estaProcessandoAcao.value = true
    deletarTiposDeAtividadeEscritor.mudarArgumentos([id, undefined])
    await deletarTiposDeAtividadeEscritor.executar()

    if (deletarTiposDeAtividadeEscritor.resultado.status == "sucesso") {
      listarTiposDeAtividade(lerTiposDeAtividade.paginaAtual)
      fecharModal()
    }

    if (deletarTiposDeAtividadeEscritor.resultado.status === "erro") {
      onErroToast(t("ocorreuUmErroAoExcluirTipoDeAtividade"), t("erroAoExcluirTipoDeAtividade"))
    }
    estaProcessandoAcao.value = false
  }

  const confirmarArquivacao = async (id: string) => {
    estaProcessandoAcao.value = true
    arquivarTipoDeAtividadeEscritor.mudarArgumentos([id])
    await arquivarTipoDeAtividadeEscritor.executar()
    
    if (arquivarTipoDeAtividadeEscritor.resultado.status === "sucesso") {
      listarTiposDeAtividade(lerTiposDeAtividade.paginaAtual)
      fecharModal()
    }

    if (arquivarTipoDeAtividadeEscritor.resultado.status === "erro") {
      onErroToast(t("ocorreuUmErroAoArquivarTipoDeAtividade"), t("erroAoArquivarTipoDeAtividade"))
    }
    estaProcessandoAcao.value = false
  }

  const confirmarDesarquivacao = async (id: string) => {
    estaProcessandoAcao.value = true
    desarquivarTipoDeAtividadeEscritor.mudarArgumentos([id, undefined])
    await desarquivarTipoDeAtividadeEscritor.executar()
    
    if (desarquivarTipoDeAtividadeEscritor.resultado.status === "sucesso") {
      listarTiposDeAtividade(lerTiposDeAtividade.paginaAtual)
      fecharModal()
    }

    if (desarquivarTipoDeAtividadeEscritor.resultado.status === "erro") {
      onErro({
        resumo: t("erroAoDesarquivarTipoDeAtividade"),
        detalhes: t("ocorreuUmErroAoDesarquivarTipoDeAtividade"),
      })
    }
    estaProcessandoAcao.value = false
  }

  const fecharModal = () => {
    dadosDoAlerta.visivel = false
    acaoAtual.value = null
  }

  const irParaEditarTipoDeAtividade = (id: string) => {
    router.push("/criar-tipo-de-atividade/" + id)
  }

  const filtrarTiposDeAtividade = async () => {
    lerTiposDeAtividade.sobrescreverParametros({
      ...filtrosComposable.value,
    })

    await listarTiposDeAtividade(
      lerTiposDeAtividade.primeiraPagina,
      lerTiposDeAtividade.itensPorPagina
    )
  }
  const limparFiltros = async (nome: string, filterCallback) => {
    removerFiltro(nome)
    filterCallback()
    filtrarTiposDeAtividade()
  }
  const aplicarFiltros = async (
    dadosDoPreenchimentoDoFiltro: Record<string, any>,
    nomeDaColunaNaAPI: string
  ) => {
    const { matchMode, value } = (
      dadosDoPreenchimentoDoFiltro as DataTableFilterMeta
    ).constraints[0]

    preencherFiltro(nomeDaColunaNaAPI, matchMode, value)
    filtrarTiposDeAtividade()
  }

  const onPaginarTiposDeAtividade = ({ page, rows }: PageState) => {
    listarTiposDeAtividade(page, rows)
  }

  onMounted(() => {
    listarTiposDeAtividade(lerTiposDeAtividade.primeiraPagina)
  })

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(DataTable), {
      filters: filtros.value,
      "onUpdate:filters": [
        _cache[0] || (_cache[0] = ($event: any) => ((filtros).value = $event)),
        filtrarTiposDeAtividade
      ],
      class: "OTabelaTiposDeAtividade p-datatable-sm",
      "data-key": "id",
      "data-testid": "OTabelaTiposDeAtividade",
      "filter-display": "menu",
      "global-filters-fields": ['nome', 'codigo'],
      loading: _unref(carregandoTiposDeAtividade),
      "responsive-layout": "scroll",
      "row-class": _unref(desativarLinhaPorStatus),
      rows: _unref(lerTiposDeAtividade).itensPorPagina,
      "scroll-height": ALTURA_RELATIVA_DA_TABELA,
      scrollable: "",
      "striped-rows": "",
      value: tiposDeAtividade.value
    }, _createSlots({
      loading: _withCtx(() => [
        _createVNode(_component_Skeleton, {
          height: "100%",
          width: "100%"
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(APaginadorDeTabela), {
          "ao-paginar": onPaginarTiposDeAtividade,
          leitor: _unref(lerTiposDeAtividade)
        }, null, 8, ["leitor"])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          class: "OTabelaTiposDeAtividade__Column",
          field: "nome",
          header: _unref(t)('nome'),
          "show-add-button": false,
          "show-filter-operator": false,
          sortable: "",
          style: _normalizeStyle(estilo.colunas.nome)
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(data.nome), 1)
          ]),
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_unref(MInput), {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              nome: "filtro-nome",
              placeholder: _unref(t)('pesquisarPorNome'),
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (limparFiltros('nome', filterCallback))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('limpar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          filterapply: _withCtx(({ filterModel, field }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (aplicarFiltros(filterModel, field))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('aplicar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["header", "style"]),
        _createVNode(_unref(Column), {
          class: "OTabelaTiposDeAtividade__Column",
          field: "codigo",
          header: _unref(t)('codigo'),
          "show-add-button": false,
          "show-filter-operator": false,
          style: _normalizeStyle(estilo.colunas.codigo)
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(data.codigo), 1)
          ]),
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_unref(MInput), {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              nome: "codigo",
              placeholder: _unref(t)('pesquisarPorCodigo'),
              type: "text"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (limparFiltros('codigo', filterCallback))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('limpar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          filterapply: _withCtx(({ filterModel, field }) => [
            _createVNode(_unref(PButton), {
              onClick: ($event: any) => (aplicarFiltros(filterModel, field))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('aplicar')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["header", "style"]),
        _createVNode(_unref(Column), {
          class: "OTabelaTiposDeAtividade__Column",
          field: "duracaoPadraoEmMinutos",
          header: _unref(t)('duracaoPadrao'),
          "show-add-button": false,
          "show-filter-operator": false,
          sortable: "",
          style: _normalizeStyle(estilo.colunas.duracaoPadraoEmMinutos)
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(formatarDuracao(data.duracaoPadraoEmMinutos)), 1)
          ]),
          _: 1
        }, 8, ["header", "style"]),
        _createVNode(_unref(Column), {
          class: "OTabelaTiposDeAtividade__Column",
          field: "atributosEsperados",
          header: _unref(t)('atributosEsperados'),
          "show-add-button": false,
          "show-filter-operator": false,
          style: _normalizeStyle(estilo.colunas.atributosEsperados)
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_unref(OAtributosChips), {
              class: "OTabelaTiposDeAtividade__MListaChips",
              "ids-atributos": data.atributosEsperados || []
            }, null, 8, ["ids-atributos"])
          ]),
          _: 1
        }, 8, ["header", "style"]),
        _createVNode(_unref(Column), {
          class: "OTabelaTiposDeAtividade__Column OTabelaTiposDeAtividade__Actions",
          field: "acoes",
          header: "",
          "show-add-button": false,
          "show-filter-operator": false,
          style: _normalizeStyle(estilo.colunas.acoes)
        }, {
          body: _withCtx(({ data }) => [
            (
              temPermissaoParaAlterarTiposDeAtividade(data.idUsuarioCriador)
            )
              ? _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                  key: 0,
                  onClick: ($event: any) => (irParaEditarTipoDeAtividade(data.id)),
                  class: "OTabelaTiposDeAtividade__IButton p-button-rounded",
                  icon: "pi pi-pencil"
                }, null, 8, ["onClick"])), [
                  [
                    _directive_tooltip,
                    _unref(t)('editar'),
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (
              !data.ativo &&
                temPermissaoParaAlterarTiposDeAtividade(data.idUsuarioCriador)
            )
              ? _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                  key: 1,
                  onClick: ($event: any) => (desativarTipoDeAtividade(data.nome, data.id)),
                  class: "OTabelaTiposDeAtividade__IButton p-button-rounded",
                  "data-testid": "OTabelaTiposDeAtividade__BotaoExcluir",
                  icon: "pi pi-trash"
                }, null, 8, ["onClick"])), [
                  [
                    _directive_tooltip,
                    _unref(t)('excluir'),
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (
              data.ativo &&
                temPermissaoParaAlterarTiposDeAtividade(data.idUsuarioCriador)
            )
              ? _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                  key: 2,
                  onClick: ($event: any) => (arquivarTipoDeAtividade(data.nome, data.id)),
                  class: "OTabelaTiposDeAtividade__IButton p-button-rounded",
                  "data-testid": "OTabelaTiposDeAtividade__Arquivar",
                  icon: "pi pi-eye-slash"
                }, null, 8, ["onClick"])), [
                  [
                    _directive_tooltip,
                    _unref(t)('arquivar'),
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (
              !data.ativo &&
                temPermissaoParaAlterarTiposDeAtividade(data.idUsuarioCriador)
            )
              ? _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                  key: 3,
                  onClick: ($event: any) => (desarquivarTipoDeAtividade(data.nome, data.id)),
                  class: "OTabelaTiposDeAtividade__IButton p-button-rounded",
                  "data-testid": "OTabelaTiposDeAtividade__Desarquivar",
                  icon: "pi pi-eye"
                }, null, 8, ["onClick"])), [
                  [
                    _directive_tooltip,
                    _unref(t)('desarquivar'),
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _: 2
    }, [
      (!_unref(carregandoTiposDeAtividade))
        ? {
            name: "empty",
            fn: _withCtx(() => [
              _createVNode(_unref(AEstadoVazioTabela))
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["filters", "loading", "row-class", "rows", "value"]),
    _createVNode(_unref(MModalDeAlerta), {
      modelValue: _unref(dadosDoAlerta).visivel,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(dadosDoAlerta).visivel) = $event)),
      cabecalho: _unref(dadosDoAlerta).titulo,
      class: "OTabelaTiposDeAtividade__Modal",
      "data-testid": "OTabelaTiposDeAtividade__Modal",
      "teleportar-para": __props.teleportarPara,
      tipo: _unref(dadosDoAlerta).tipo
    }, {
      conteudo: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(dadosDoAlerta).conteudo), 1)
      ]),
      acoes: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(PButton), {
            onClick: fecharModal,
            class: "OTabelaTiposDeAtividade__BotaoModalVoltar p-button-text p-button-info",
            "data-testid": "OTabelaTiposDeAtividade__BotaoModalVoltar",
            label: _unref(t)('nao')
          }, null, 8, ["label"]),
          _createVNode(_unref(PButton), {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (confirmarAcao(_unref(dadosDoAlerta).identificacao!))),
            class: "OTabelaTiposDeAtividade__BotaoModalConfirmar p-button-danger",
            "data-testid": "OTabelaTiposDeAtividade__BotaoModalConfirmar",
            label: _unref(labelModalDeConfirmacao),
            loading: estaProcessandoAcao.value
          }, null, 8, ["label", "loading"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "cabecalho", "teleportar-para", "tipo"])
  ]))
}
}

})